<template lang="pug">
section.main(v-if="datum",:class="collapsed ? 'wide' : 'narrow'")
  Header(ref="header")
  Menu
  section.page.people(ref="page",v-if="$auth.isAuthenticated && currentUser")
    b-navbar.title
      b-navbar-brand
        i.icon.fas.fa-users
        span {{ page.title }}
        template(v-if="mode !== 'add'")
          span.mx-2 /
          a(:href="`/${$route.params.directory}/people/${datum._id}`") 候補者状況
      b-navbar-nav.ml-auto
        b-nav-item
          b-button(variant="link",@click="onClose()") 一覧へ戻る

    section.body(ref="body")
      ValidationObserver(slim,ref="observer")
        b-form.form(ref="form",:data-mode="mode",@submit.prevent)
          b-container(fluid)
            b-row.pt-3.mb-2
              b-col
                h5.pl-2 基本情報
            b-row
              b-col
                b-container.border.rounded(fluid)
                  b-row.mt-3
                    b-col(cols=6)
                      b-form-group(label="ポジション",label-for="input-job",description="",required)
                        ValidationProvider(rules="required",name="ポジション",v-slot="{ errors }")
                          b-form-select#input-job(v-model="datum.jobId",:options="options.job",required,@change="validateInput",:disabled="!editable || mode !== 'add'",:readonly="!editable || mode !== 'add'")
                          .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                    b-col(cols=6)
                      b-form-group(label="応募ルート",label-for="input-route",description="",required)
                        ValidationProvider(rules="required",name="応募ルート",v-slot="{ errors }")
                          b-form-select#input-route(v-model="datum.routeId",:options="options.route",required,@change="validateInput",:disabled="!editable || mode !== 'add'",:readonly="!editable || mode !== 'add'")
                          .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}

                  b-row
                    b-col(cols=6)
                      b-form-group(label="応募日",label-for="input-appliedAt",description="",required)
                        .form-inline.d-flex.align-items-start
                          ValidationProvider(rules="required|date",name="応募日",v-slot="{ errors }")
                            b-input-group
                              b-form-input#input-appliedAt(v-model="datum.appliedAt",type="date",placeholder="年/月/日",pattern="((19|20)\d\d)[\/\-]([1-9]|0[1-9]|1[012])[\/\-]([1-9]|0[1-9]|[12][0-9]|3[01])",required,@input="validateInput",:disabled="!editable",:readonly="!editable")
                              //-b-input-group-append
                                //b-form-datepicker(v-model="datum.appliedAt",button-only,locale="ja-JP",:date-format-options="{ year:'numeric', month: '2-digit', day: '2-digit', weekday: 'narrow' }",placeholder="応募日を設定してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                            .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}

            b-row.mt-3.mb-2
              b-col
                h5.pl-2 候補者情報
            b-row
              b-col
                b-container.border.rounded(fluid)
                  b-row.mt-3
                    b-col(cols=6)
                      b-form-group(label="氏名（姓）",label-for="input-lastName",description="",required)
                        ValidationProvider(rules="required|max:50",name="氏名（姓）",v-slot="{ errors }")
                          b-form-input#input-lastName(ref="input-lastName",v-model="datum.lastName",type="text",required,placeholder="氏名（姓）を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                          .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                    b-col(cols=6)
                      b-form-group(label="氏名（名）",label-for="input-firstName",description="",required)
                        ValidationProvider(rules="required|max:50",name="氏名（名）",v-slot="{ errors }")
                          b-form-input#input-firstName(ref="input-firstName",v-model="datum.firstName",type="text",required,placeholder="氏名（名）を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                          .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                  b-row
                    b-col(cols=6)
                      b-form-group(label="カナヨミ（姓）",label-for="input-lastKana",description="",:required="currentUser && currentUser.role === 'agent'")
                        ValidationProvider(:rules="{ required: currentUser && currentUser.role === 'agent', kana: true, max: 50 }",name="カナヨミ（姓）",v-slot="{ errors }")
                          b-form-input#input-lastKana(ref="input-lastKana",v-model="datum.lastKana",type="text",placeholder="カナヨミ（姓）を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                          .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                    b-col(cols=6)
                      b-form-group(label="カナヨミ（名）",label-for="input-firstKana",description="",:required="currentUser && currentUser.role === 'agent'")
                        ValidationProvider(:rules="{ required: currentUser && currentUser.role === 'agent', kana: true, max: 50 }",name="カナヨミ（名）",v-slot="{ errors }")
                          b-form-input#input-firstKana(ref="input-firstKana",v-model="datum.firstKana",type="text",placeholder="カナヨミ（名）を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                          .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                  b-row
                    b-col(cols=6)
                      b-form-group(label="生年月日",label-for="input-birth_year",description="",:required="currentUser && currentUser.role === 'agent'")
                        .form-inline.d-flex.align-items-center
                          ValidationProvider(ref="validate-birth_year",:rules="{ required: currentUser && currentUser.role === 'agent', isEmployableYear: true, min_value: birthYearMin , max_value: birthYearMax }",name="生年月日（年）",v-slot="{ errors }")
                            b-input-group
                              b-form-input#input-birth_year(ref="input-birth_year",v-model="birth.year",type="number",placeholder="年",@input="validateInput",:disabled="!editable",:readonly="!editable")
                            .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                          .mx-2 年
                          ValidationProvider(ref="validate-birth_month",rules="min_value:1|max_value:12",name="生年月日（月）",v-slot="{ errors }")
                            b-input-group
                              b-form-input#input-birth_month(ref="input-birth_month",v-model="birth.month",type="number",placeholder="月",@input="validateInput",:disabled="!editable",:readonly="!editable")
                            .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                          .mx-2 月
                          ValidationProvider(ref="validate-birth_day",rules="min_value:1|max_value:31",name="生年月日（日）",v-slot="{ errors }")
                            b-input-group
                              b-form-input#input-birth_day(ref="input-birth_day",v-model="birth.day",type="number",placeholder="日",@input="validateInput",:disabled="!editable",:readonly="!editable")
                            .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                          .ml-2 日
                      .form-control-feedback.text-danger(v-if="editable && invalidBirthday") 生年月日が正しくありません
                    b-col(cols=6)
                      b-form-group(label="性別",label-for="radio-gender",description="",:required="currentUser && currentUser.role === 'agent'")
                        ValidationProvider(rules="",name="性別",v-slot="{ errors }")
                          b-form-radio-group#radio-gender(v-model="datum.gender",@input="validateInput")
                            b-form-radio(value="0") 不明
                            b-form-radio(value="1") 男性
                            b-form-radio(value="2") 女性
                            b-form-radio(value="9") 適用不能
                          .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                  b-row
                    b-col(cols=6)
                      b-form-group(label="携帯電話番号",label-for="input-mobile",description="")
                        ValidationProvider(:rules="{ regex: /^0[0-9]{1,4}\-?[0-9]{1,4}\-?[0-9]{4}$/, min: 10, max: 20 }",name="携帯電話番号",v-slot="{ errors }")
                          b-form-input#input-mobile(v-model="datum.mobile",type="tel",placeholder="携帯電話番号を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                          .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                    b-col(cols=6)
                      b-form-group(label="メールアドレス",label-for="input-email",description="")
                        ValidationProvider(rules="email|max:120",name="メールアドレス",v-slot="{ errors }")
                          b-form-input#input-email(v-model="datum.email",type="email",placeholder="メールアドレスを入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                          .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                  b-row
                    b-col(cols=6)
                      b-form-group(label="郵便番号",label-for="input-zip",description="")
                        ValidationProvider(:rules="{ regex: /^[0-9]{3}-?[0-9]{4}$/ }",name="郵便番号",v-slot="{ errors }")
                          b-form-input#input-zip(v-model="datum.zip",type="text",placeholder="郵便番号を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                          .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                    b-col(cols=6)
                      b-form-group(label="都道府県",label-for="input-state",description="")
                        ValidationProvider(rules="",name="都道府県",v-slot="{ errors }")
                          b-form-select#input-prefecture(v-model="datum.prefecture",:options="options.prefectures",@change="validateInput",:disabled="!editable",:readonly="!editable")
                          .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                  b-row
                    b-col
                      b-form-group(label="市区町村・番地",label-for="input-locality",description="")
                        ValidationProvider(rules="max:100",name="市区町村・番地",v-slot="{ errors }")
                          b-form-input#input-locality(v-model="datum.locality",type="text",placeholder="市区町村・番地を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                          .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                  b-row
                    b-col
                      b-form-group(label="ビル・マンション名など",label-for="input-building",description="")
                        ValidationProvider(rules="max:100",name="ビル・マンション名",v-slot="{ errors }")
                          b-form-input#input-building(v-model="datum.building",type="text",placeholder="ビル・マンション名を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                          .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}

                  b-row
                    b-col
                      b-form-group(label="現在の年収",label-for="input-salary",description="",:required="currentUser && currentUser.role === 'agent'")
                        ValidationProvider(:rules="{ required: currentUser && currentUser.role === 'agent' }",name="現在の年収",v-slot="{ errors }")
                          b-form-input#input-salary(v-model="datum.salary",type="text",placeholder="現在の年収を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                          .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}

            b-row.mt-3.mb-2
              b-col.d-flex.justify-content-between
                .form-group.mb-0
                  label 参考URL
            b-row
              b-col.links
                b-card.mb-3(no-body,v-for="(link, index) in datum.links",:key="index")
                  b-card-title.position-absolute
                    b-button.removeLinks(variant="link",@click="removeLinks(index)",:disabled="!editable || (datum.links && datum.links.length <= 0)")
                      i.menu-icon.fas.fa-minus-circle
                  b-card-body.p-0
                    b-container.border.rounded(fluid)
                      b-row.mt-3
                        b-col(cols=4)
                          b-form-group(label="名称",:label-for="`input-link_${index + 1}-caption`",description="")
                            ValidationProvider(rules="max:100",:name="`名称(${index + 1}行目)`",v-slot="{ errors }")
                              b-form-input.input-links-caption(:id="`input-link_${index + 1}-caption`",v-model="link.caption",@change="validateInput",:disabled="!editable",:readonly="!editable")
                              .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                        b-col(cols=8)
                          b-form-group(label="URL",:label-for="`input-link_${index + 1}-url`",description="",required)
                            ValidationProvider(rules="required|max:200",:name="`URL${index + 1}行目）`",v-slot="{ errors }")
                              b-form-input.input-links-url(:id="`input-link_${index + 1}-url`",v-model="link.url",type="text",required,placeholder="URLを入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                              .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}

                template(v-if="editable")
                  b-button.addLinks(variant="link",@click="addLinks()",:disabled="!editable || (datum.links && datum.links.length >= 10)")
                    i.align-middle.menu-icon.fas.fa-plus-circle
                    span.align-middle.ml-2 参考URLを追加
                template(v-else)
                  p

            b-row.mt-3.mb-2
              b-col
                .form-group.mb-0(:required="currentUser && currentUser.role === 'agent'")
                  label 添付ファイル
            b-row
              b-col
                b-container.border.rounded(fluid)
                  b-row.mt-3
                    b-col
                      template(v-if="editable")
                        b-form-group.uploadFile(label="履歴書や職務経歴書など（複数ファイル添付可能）",label-for="uploadFile",description="")
                          b-form-file#uploadFile(ref="uploadFile",v-model="uploadFile",browse-text="選択",placeholder="アップロードしたいファイルを選択してください",drop-placeholder="ファイルをドラッグ＆ドロップしてください。",@input="validateInput",:disabled="!editable",:readonly="!editable")
                          .form-control-feedback.text-danger.mb-3(v-if="isRequireFile") 添付ファイルをアップロードしてください
                        .uploadFiles
                          p.text-muted アップロードするファイル
                          .ml-2.mb-3.d-flex.flex-wrap
                            template(v-if="!uploadFiles || (uploadFiles && uploadFiles.length === 0)")
                              span.text-muted.no-uploadFiles なし
                            template(v-else)
                              .file.text-nowrap.mr-2(v-if="editable",v-for="(file, index) in uploadFiles",:key="index")
                                span.name {{file.name}}
                                b-button.removeUpdateFiles(variant="link",size="sm",@click="removeUploadFile(index)")
                                  i.menu-icon.fas.fa-minus-circle
                      .files(v-if="datum.Files && datum.Files.length > 0")
                        p.text-muted アップロード済みのファイル
                        .ml-2.mr-0.mb-3.d-flex.flex-wrap
                          span.file.mr-3.mb-2(v-for="(file, index) in datum.Files",:key="index",:class="file.remove ? 'remove' : ''")
                            b-button.p-0.text-left(variant="link",@click="selectPeopleFile(file, datum)")
                              span.text-wrap {{ file.filename }}
                            b-button.removeFiles(v-if="editable",variant="link",size="sm",@click="removeFile(index)")
                              i.menu-icon.fas.fa-minus-circle

            b-row.mt-3
              b-col.d-flex.justify-content-between
                .form-group.mb-0(:required="currentUser && currentUser.role === 'agent'")
                  label 学歴情報
            b-row.mb-2
              b-col.pl-4
                .form-control-feedback.text-danger(v-if="(!datum.educations || (datum && datum.educations && datum.educations.length === 0)) && isRequireEducation") 学歴を入力してください
            b-row
              b-col.educations
                b-card.mb-3(no-body,v-for="(education, index) in datum.educations",:key="index")
                  b-card-title.position-absolute
                    b-button.removeEducations(variant="link",@click="removeEducations(index)",:disabled="!editable || (datum && datum.educations && datum.educations.length <= 0)")
                      i.menu-icon.fas.fa-minus-circle
                  b-card-body.p-0
                    b-container.border.rounded(fluid)
                      b-row.mt-3
                        b-col(cols=4)
                          b-form-group(label="種別",:label-for="`input-education_${index + 1}-qualify`",description="",required)
                            ValidationProvider(rules="required",:name="`種別(${index + 1}行目)`",v-slot="{ errors }")
                              b-form-select.input-educations-qualify(:id="`input-education_${index + 1}-qualify`",v-model="education.qualification",:options="options.qualification",required,@change="validateInput",:disabled="!editable",:readonly="!editable")
                              .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                        b-col(cols=8)
                          b-form-group(label="学校名",:label-for="`input-education_${index + 1}-name`",description="",required)
                            ValidationProvider(rules="required|max:100",:name="`学校名（${index + 1}行目）`",v-slot="{ errors }")
                              b-form-input.input-educations-name(:id="`input-education_${index + 1}-name`",v-model="education.schoolName",type="text",required,placeholder="学校名を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                              .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                      b-row
                        b-col(cols=4)
                          b-form-group(label="入学年月",:label-for="`input-education_${index + 1}-enrolledAt`",description="")
                            ValidationProvider(rules="",:name="`入学年月(${index + 1}行目)`",v-slot="{ errors }")
                              v-monthly-picker.input-educations-enrolledAt(:id="`input-education_${index + 1}-enrolledAt`",v-model="education.enrolledAt",:monthLabels="monthLabels",@input="validateInput",:disabled="!editable",:readonly="!editable")
                              .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                        b-col(cols=4)
                          b-form-group(label="卒業年月",:label-for="`input-education_${index + 1}-graduatedAt`",description="")
                            ValidationProvider(rules="",:name="`卒業年月(${index + 1}行目)`",v-slot="{ errors }")
                              v-monthly-picker.input-educations-graduatedAt(:id="`input-education_${index + 1}-graduatedAt`",v-model="education.graduatedAt",:monthLabels="monthLabels",@input="validateInput",:disabled="!editable",:readonly="!editable")
                              .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}

                template(v-if="editable")
                  b-button.addEducations(variant="link",@click="addEducations()",:disabled="!editable || (datum && datum.educations && datum.educations.length >= 10)")
                    i.align-middle.menu-icon.fas.fa-plus-circle
                    span.align-middle.ml-2 学歴を追加
                template(v-else)
                  p

            b-row.mt-3.mb-2
              b-col.d-flex.justify-content-between
                .form-group.mb-0(:required="currentUser && currentUser.role === 'agent'")
                  label 職歴情報
            b-row.mb-2
              b-col.pl-4
                .form-control-feedback.text-danger(v-if="(!datum.careers || (datum && datum.careers && datum.careers.length === 0)) && isRequireCareer") 職歴を入力してください
            b-row
              b-col.careers
                b-card.mb-3(no-body,v-for="(career, index) in datum.careers",:key="index")
                  b-card-title.position-absolute
                    b-button.removeCareers(variant="link",@click="removeCareers(index)",:disabled="!editable || (datum && datum.careers && datum.careers.length < 0)")
                      i.menu-icon.fas.fa-minus-circle
                  b-card-body.p-0
                    b-container.border.rounded(fluid)
                      b-row.mt-3
                        b-col(cols=4)
                          b-form-group(label="雇用形態",:label-for="`input-career_${index + 1}-type`",description="",required)
                            ValidationProvider(rules="required",:name="`雇用形態(${index + 1}行目)`",v-slot="{ errors }")
                              b-form-select.input-career-type(:id="`input-career_${index + 1}-type`",v-model="career.type",:options="options.careerType",required,@change="validateInput",:disabled="!editable",:readonly="!editable")
                              .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                        b-col(cols=8)
                          b-form-group.mb-2(label="会社名",:label-for="`input-career_${index + 1}-name`",description="",required)
                            ValidationProvider.box(rules="required|max:100",:name="`会社名（${index + 1}行目）`",v-slot="{ errors }")
                              b-form-input.input-careers-name(:id="`input-career_${index + 1}-name`",v-model="career.companyName",type="text",required,placeholder="会社名を入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                              .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                      b-row
                        b-col(cols=4)
                          b-form-group(label="入社年月",:label-for="`input-career_${index + 1}-joinedAt`",description="")
                            ValidationProvider(rules="",:name="`入社年月(${index + 1}行目)`",v-slot="{ errors }")
                              v-monthly-picker.input-careers-joinedAt(:id="`input-career_${index + 1}-joinedAt`",v-model="career.joinedAt",:monthLabels="monthLabels",@input="validateInput",:disabled="!editable",:readonly="!editable")
                              .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
                        b-col(cols=4)
                          b-form-group(label="退社年月",:label-for="`input-career_${index + 1}-retiredAt`",description="")
                            ValidationProvider(rules="",:name="`退社年月(${index + 1}行目)`",v-slot="{ errors }")
                              v-monthly-picker.input-careers-retiredAt(:id="`input-career_${index + 1}-retiredAt`",v-model="career.retiredAt",:monthLabels="monthLabels",@input="validateInput",:disabled="!editable",:readonly="!editable")
                              .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}

                template(v-if="editable")
                  b-button.addCareers(variant="link",@click="addCareers()",:disabled="!editable || (datum.careers && datum.careers.length >= 10)")
                    i.align-middle.menu-icon.fas.fa-plus-circle
                    span.align-middle.ml-2 職歴を追加
                template(v-else)
                  p

            b-row.mt-3.mb-2
              b-col
                b-form-group(label="補足情報・メモ",label-class="h6",label-for="input-note",description="")
                  ValidationProvider(rules="max:4000",name="補足情報・メモ",v-slot="{ errors }")
                    b-form-textarea#input-note(v-model="datum.note",type="text",max-rows="20",placeholder="補足情報・メモなどある場合、こちらに入力してください",@input="validateInput",:disabled="!editable",:readonly="!editable")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}

        b-navbar.border-top.bottom-nav.bg-secondary
          b-navbar-nav
            b-nav-item
              b-button(variant="primary",v-show="mode === 'add' || mode === 'edit'",@click="onSave()",:disabled="!valid || !changed")
                span 保存
          b-navbar-nav.ml-auto
            b-nav-item
              b-button(v-if="currentUser && currentUser.acl && currentUser.acl.peoples && currentUser.acl.peoples.delete",variant="outline-danger",@click="onDelete()")
                span 削除

  b-modal#modal-preview(hide-header,size="xl",@shown="shownPeopleFile",@hidden="hiddenPeopleFile")
    template(v-slot:default)
      .previewWrapper(v-if="previewFile")
        template(v-if="previewFile && (previewFile.extension === 'png' || previewFile.extension === 'jpeg' || previewFile.extension === 'gif' || previewFile.extension === 'bmp' || previewFile.extension === 'svg')")
          img.img-fluid.mx-auto#previewPeopleFile
        template(v-if="previewFile && previewFile.extension === 'pdf'")
          #previewPeopleFile.pdf
        template(v-if="previewFile && previewFile.extension === 'markdown'")
          #previewPeopleFile.markdown
    template(v-slot:modal-footer="{ ok, cancel }")
      b-button(variant="primary",@click="downloadPeopleFile") ダウンロード
      b-button(variant="secondary",@click="$bvModal.hide('modal-preview')") 閉じる
</template>

<script>
import { isEqual } from 'lodash'

import QueryHash from 'query-hash'

import { getData, postData, patchData, deleteData, postFiles } from '../utils/api'

import { clone, difference, optionsPrefecture, optionsAcademicQualification, optionsCareerType, getMonthLabels } from '../utils/libs'

import 'dayjs/locale/ja'
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'

dayjs.locale('ja')
dayjs.extend(localizedFormat)

const page = {
  id: 'people',
  title: '候補者情報'
}

export default {
  // props: ['mode'],
  data () {
    return {
      mask: false,
      lock: false,
      page: page,
      collapsed: true,
      currentUser: null,
      mode: null,
      editable: null,
      changed: false,
      valid: false,
      birthYearMin: dayjs().subtract(110, 'years').year(),
      birthYearMax: dayjs().subtract(10, 'years').year(),
      invalidBirthday: false,
      isRequireFile: false,
      isRequireEducation: false,
      isRequireCareer: false,
      datum: {},
      recentDatum: {},
      uploadFile: null,
      uploadFiles: [],
      options: {
        prefecture: [],
        job: [],
        route: [],
        qualification: [],
        careerType: []
      },
      birth: {
        year: null,
        month: null,
        day: null
      },
      noneEducation: true,
      noneCareer: true,
      monthLabels: getMonthLabels(),
      previewFile: null
    }
  },
  watch: {
    mode (newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        this.changeMode()
      }
    },
    uploadFile (file) {
      if (file) {
        this.uploadFiles.push(file)

        this.$refs['uploadFile'].reset()
        // this.uploadFile = null

        this.validateInput()
      }
    },
    'datum.zip' (val) {
      this.changeZip()
    }
  },
  created () {
    let yubinbangoScript = document.createElement('script')
    yubinbangoScript.setAttribute('src', 'https://yubinbango.github.io/yubinbango-core/yubinbango-core.js')
    document.head.appendChild(yubinbangoScript)
  },
  async mounted () {
    this.mode = 'add'
    this.editable = true
    if (this.$route.params.id) {
      this.id = this.$route.params.id
      this.mode = 'show'
      this.editable = false
    }

    this.options.prefectures = optionsPrefecture()
    this.options.prefectures.unshift({
      value: null, text: '都道府県を選択してください' //, disabled: true
    })

    this.options.qualification = optionsAcademicQualification()
    this.options.qualification.unshift({
      value: null, text: '学校の種別を選択' //, disabled: true
    })

    this.options.careerType = optionsCareerType()
    this.options.careerType.unshift({
      value: null, text: '雇用形態を選択' //, disabled: true
    })

    this.options.job = []
    await getData(`/jobs?sort=occupation,position&limit=-1`).then((data) => {
      for (let datum of data) {
        this.options.job.push({
          value: datum._id, text: datum.name
        })
      }
    }).catch((err) => {
      console.log(err)
    })
    this.options.job.unshift({
      value: null, text: 'ポジションを選択してください' //, disabled: true
    })

    this.options.route = []
    await getData(`/routes?sort=postedAt&limit=-1`).then((data) => {
      for (let datum of data) {
        this.options.route.push({
          value: datum._id, text: datum.name
        })
      }
    }).catch((err) => {
      console.log(err)
    })
    this.options.route.unshift({
      value: null, text: '応募ルートを選択してください' //, disabled: true
    })

    this.changeMode()
  },
  methods: {
    selectPeopleFile (file, people) {
      if (file.extension === 'png' || file.extension === 'jpeg' || file.extension === 'gif' || file.extension === 'bmp' || file.extension === 'svg' || file.extension === 'pdf' || file.extension === 'markdown') {
        this.previewPerson = people
        this.previewFile = file
        this.$bvModal.show('modal-preview')
      } else {
        this.download(`/peoples/${people._id}/files/${file._id}.${file.extension}`, `${file.filename}`)
      }
    },
    shownPeopleFile () {
      this.preview(`/peoples/${this.previewPerson._id}/files/${this.previewFile._id}.${this.previewFile.extension}`, `${this.previewFile.filename}`, 'previewPeopleFile')
    },
    hiddenPeopleFile () {
      this.previewPerson = null
      this.previewFile = null
    },
    downloadPeopleFile () {
      this.download(`/peoples/${this.previewPerson._id}/files/${this.previewFile._id}.${this.previewFile.extension}`, `${this.previewFile.filename}`)
    },
    changeZip () {
      if (this.mask) { return }
      if (this.datum.zip && this.datum.zip.match(/^[0-9]{3}-?[0-9]{4}$/)) {
        const self = this
        new YubinBango.Core(this.datum.zip, (address) => {
          this.$set(self.datum, 'prefecture', address.region)
          this.$set(self.datum, 'locality', address.locality + address.street)
        })
      }
    },
    async validateInput () {
      await this.$refs.observer.reset()
      this.valid = await this.$refs.observer.validate()

      this.isRequireFile = false
      this.isRequireEducation = false
      this.isRequireCareer = false

      this.invalidBirthday = false

      const year = this.$refs['input-birth_year'].value
      const month = this.$refs['input-birth_month'].value
      const day = this.$refs['input-birth_day'].value

      if (year && month && day) {
        let validBirthday = true
        let ret = await this.$refs['validate-birth_year'].validate()
        validBirthday = ret.valid
        if (ret.valid) {
          ret = await this.$refs['validate-birth_month'].validate()
          validBirthday = ret.valid
        }
        if (ret.valid) {
          ret = await this.$refs['validate-birth_day'].validate()
          validBirthday = ret.valid
        }

        if (validBirthday) {
          try {
            const birthday = new Date(dayjs(`${String(year)}-${String(month)}-${String(day)}`).format('YYYY-MM-DD'))
            if (Number(year) !== birthday.getYear() + 1900) {
              validBirthday = false
            } else if (Number(month) !== birthday.getMonth() + 1) {
              validBirthday = false
            } else if (Number(day) !== birthday.getDate()) {
              validBirthday = false
            }
          } catch (e) {
            validBirthday = false
          }
        }
        this.invalidBirthday = !validBirthday
      }

      delete this.datum.birthday
      delete this.datum.birthYear
      delete this.datum.birthMonth

      if (!this.invalidBirthday) {
        if (year && month && day) {
          this.datum.birthday = dayjs(`${String(year)}-${String(month)}-${String(day)}`).format('YYYY-MM-DD')
        } else if (year) {
          this.datum.birthYear = String(year)
          if (month) {
            this.datum.birthMonth = String(month)
          }
        }
      }

      if (this.currentUser.role === 'agent') {
        if (this.mode === 'add') {
          if (!this.uploadFiles || (this.uploadFiles && this.uploadFiles.length === 0)) {
            this.isRequireFile = true
            this.valid = false
          }
        }

        if (!this.datum.educations || (this.datum.educations && this.datum.educations.length === 0)) {
          this.isRequireEducation = true
          this.valid = false
        }

        if (!this.datum.careers || (this.datum.careers && this.datum.careers.length === 0)) {
          this.isRequireCareer = true
          this.valid = false
        }
      }

      /*
      if (this.datum.links && this.datum.links.length > 0) {
        let isEmptyLink = false
        this.datum.links.forEach((link) => {
          if (!link.caption || !link.url) {
            isEmptyLink = true
          }
        })
        if (!isEmptyLink && this.datum.links.length > 0) {
          this.valid = false
        }
      }

      if (this.datum.educations && this.datum.educations.length > 0) {
        let isEmptyEducation = false
        this.datum.educations.forEach((education) => {
          if (!education.schoolName || !education.graduatedIn) {
            isEmptyEducation = true
          }
        })
        if (!isEmptyEducation && this.datum.educations.length > 0) {
          this.valid = false
        }
      }

      if (this.datum.careers && this.datum.careers.length > 0) {
        let isEmptyCareer = false
        this.datum.careers.forEach((career) => {
          if (!career.companyName || !career.joinedIn) {
            isEmptyCareer = true
          }
        })

        if (!isEmptyCareer && this.datum.careers.length > 0) {
          this.valid = false
        }
      }
      */

      let currentDatum = clone(this.datum)

      const diffDatum = difference(currentDatum, this.recentDatum)
      if (!isEqual({}, diffDatum)) {
        this.changed = true
      }

      if (!this.changed && this.uploadFiles.length > 0) {
        this.changed = true
      }

      if (!this.changed) {
        if (this.datum.Files) {
          const isRemoveFile = this.datum.Files.find((file) => {
            return file.remove
          })
          if (isRemoveFile) {
            this.changed = true
          }
        }
      }

      this.recentDatum = clone(this.datum)
    },
    changeMode () {
      if (this.mode === 'add' || this.mode === 'edit') {
        this.editable = true
      } else {
        this.editable = false
      }
      if (this.mode === 'list' || this.mode === 'status') {
        this.lock = false
      } else {
        this.lock = true
      }
      this.loadData()
    },
    async loadData () {
      if (!this.mode || this.mode === 'list' || this.mode === 'status') { return }

      this.mask = true

      if (!this.$root.currentUser || !this.$root.currentUser.role) {
        setTimeout(() => {
          this.loadData()
        }, 300)
        return
      }
      this.$set(this, 'currentUser', this.$root.currentUser)

      let message = null

      this.datum = {}
      this.recentDatum = {}

      this.uploadFiles = []

      if (this.mode === 'add') {
        this.datum.jobId = null
        this.datum.routeId = null

        this.datum.prefecture = null

        this.datum.links = []

        this.datum.educations = []

        this.datum.careers = []

        await this.validateInput()

        this.recentDatum = clone(this.datum)

        this.birth = {
          year: null,
          month: null,
          day: null
        }

        this.changed = false
        this.valid = false

        this.$nextTick(() => {
          this.$refs.observer.reset()
        })
      } else if (this.$route.params.id) {
        if (!this.currentUser.acl || !this.currentUser.acl.peoples || !this.currentUser.acl.peoples.get) {
          this.handleLink(`/${this.$route.params.directory}/peoples`)
        }

        if (this.currentUser.acl && this.currentUser.acl.peoples && this.currentUser.acl.peoples.patch) {
          this.editable = true
          this.mode = 'edit'
        }

        await getData(`/peoples/${this.$route.params.id}`).then(async (datum) => {
          if (datum) {
            this.datum = clone(datum)

            if (this.datum.birthday) {
              const birthday = new Date(this.datum.birthday)
              this.birth = {
                year: birthday.getYear() + 1900,
                month: birthday.getMonth() + 1,
                day: birthday.getDate()
              }
            } else if (this.datum.birthYear) {
              this.birth.year = this.datum.birthYear
              this.birth.month = null
              this.birth.day = null
              if (this.datum.birthMonth) {
                this.birth.month = this.datum.birthMonth
              }
            }

            if (!this.datum.links || !Array.isArray(this.datum.links) || this.datum.links.length === 0) {
              this.datum.links = []
            }

            if (!this.datum.educations || !Array.isArray(this.datum.educations) || this.datum.educations.length === 0) {
              this.datum.educations = []
            }
            if (!this.datum.careers || !Array.isArray(this.datum.careers) || this.datum.careers.length === 0) {
              this.datum.careers = []
            }
          }

          await this.validateInput()

          this.recentDatum = clone(this.datum)

          this.changed = false
          this.valid = false
        }).catch((err) => {
          console.log(err)

          message = 'データの読込に失敗しました'

          if (err.response.data) {
            if (err.response.data.code && err.response.data.message) {
              message = err.response.data.message
            } else if (err.response.data.message) {
              message = err.response.data.message
            }
          }
        })
      }

      if (this.$refs.subpage) {
        this.$refs.subpage.scrollTop = 0
      }

      this.mask = false

      if (message) {
        this.msgBoxError(message)
      } else {
        this.$forceUpdate()
      }

      this.$nextTick(() => {
        this.$refs.observer.reset()
      })
    },
    onClose () {
      if (this.mode === 'show') {
        this.doClose()
      } else if (this.mode === 'edit') {
        if (!this.changed) {
          this.doClose()
        } else {
          this.msgBoxConfirm('内容が変更されています。変更を破棄しますか？', () => {
            this.doClose()
          })
        }
      } else if (this.mode === 'add') {
        if (!this.changed) {
          this.doClose()
        } else {
          this.msgBoxConfirm('内容が変更されています。変更を破棄しますか？', () => {
            this.doClose()
          })
        }
      }
    },
    doClose () {
      this.handleLink(`/${this.$route.params.directory}/peoples`)
    },
    onChange (elm) {
      // debugger
    },
    removeUploadFile (index) {
      this.uploadFiles.splice(index, 1)
      this.validateInput()
      this.$forceUpdate()
    },
    removeFile (index) {
      if (this.datum.Files[index].remove) {
        this.datum.Files[index].remove = false
      } else {
        this.datum.Files[index].remove = true
      }
      this.validateInput()
      this.$forceUpdate()
    },
    addLinks () {
      this.datum.links.push({
        caption: '',
        url: ''
      })
      this.validateInput()
      this.$forceUpdate()
    },
    removeLinks (index) {
      this.datum.links.splice(index, 1)
      this.validateInput()
      this.$forceUpdate()
    },
    addEducations () {
      this.datum.educations.push({
        qualification: null,
        schoolName: '',
        enrolledAt: '',
        graduatedAt: ''
      })
      this.validateInput()
      this.$forceUpdate()
    },
    removeEducations (index) {
      this.datum.educations.splice(index, 1)
      this.validateInput()
      this.$forceUpdate()
    },
    addCareers () {
      this.datum.careers.push({
        type: null,
        companyName: '',
        joinedAt: '',
        retiredAt: ''
      })
      this.validateInput()
      this.$forceUpdate()
    },
    removeCareers (index) {
      this.datum.careers.splice(index, 1)
      this.validateInput()
      this.$forceUpdate()
    },
    async onSave () {
      this.valid = await this.$refs.observer.validate()
      if (!this.valid) {
        this.msgBoxError('Invalid Inputs')
      } else {
        this.msgBoxConfirm('候補者情報を保存しますか？', this.doSave)
      }
    },
    async doSave () {
      this.mask = true

      let datum = clone(this.datum)
      console.log(datum)

      if (datum.appliedAt) {
        datum.appliedAt = dayjs(datum.appliedAt).format('YYYY-MM-DD')
      }
      if (datum.birthday) {
        datum.birthday = dayjs(datum.birthday).format('YYYY-MM-DD')
      }

      delete datum.tags
      delete datum.steps

      delete datum.postedAt
      delete datum.PostedBy
      delete datum.patchedAt
      delete datum.PatchedBy

      let message = null

      if (this.mode === 'add') {
        await postData(`/peoples/`, datum).then(async (json) => {
          this.datum._id = json._id
          if (this.uploadFiles.length) {
            await this.doUploadFiles()
          }
          /*
          this.editable = false
          this.mode = 'edit'
          this.handleLink(`/${this.$route.params.directory}/people/${json._id}`)
          this.loadData()
          */
          this.handleLink(`/${this.$route.params.directory}/people/${json._id}`)
        }).catch((err) => {
          console.log(err)

          message = 'データの保存に失敗しました'

          if (err.response.data) {
            if (err.response.data.code && err.response.data.message) {
              message = err.response.data.message
            } else if (err.response.data.message) {
              message = err.response.data.message
            }
          }
        })
      } else {
        await patchData(`/peoples/${datum._id}`, datum).then(async (json) => {
        }).catch((err) => {
          console.log(err)

          message = 'データの保存に失敗しました'

          if (err.response.data) {
            if (err.response.data.code && err.response.data.message) {
              message = err.response.data.message
            } else if (err.response.data.message) {
              message = err.response.data.message
            }
          }
        })

        if (!message || (message && message === 'Not Changed Data')) {
          if (this.uploadFiles.length > 0) {
            message = await this.doUploadFiles()
          }
        }

        if (!message || (message && message === 'Not Changed Data')) {
          if (this.datum.Files) {
            const isRemoveFile = this.datum.Files.find((file) => {
              return file.remove
            })
            if (isRemoveFile) {
              message = await this.doRemoveFiles()
            }
          }
        }

        if (!message) {
          this.handleLink(`/${this.$route.params.directory}/people/${this.datum._id}`)
        }
      }

      this.mask = false

      if (message) {
        this.msgBoxError(message)
      } else {
        this.$forceUpdate()
      }
    },
    onDelete () {
      this.msgBoxConfirm('候補者情報を削除しますか？', this.doDelete)
    },
    async doDelete () {
      this.mask = true

      let message = null

      await deleteData(`/peoples/${this.datum._id}`).then((json) => {
        this.handleLink(`/${this.$route.params.directory}/peoples`)
      }).catch((err) => {
        console.log(err)

        message = 'データの削除に失敗しました'

        if (err.response.data) {
          if (err.response.data.code && err.response.data.message) {
            message = err.response.data.message
          } else if (err.response.data.message) {
            message = err.response.data.message
          }
        }
      })

      this.mask = false

      if (message) {
        this.msgBoxError(message)
      } else {
        this.$forceUpdate()
      }
    },
    async doUploadFiles () {
      if (!this.uploadFiles || this.uploadFiles.length === 0) { return }

      let message = null

      for (let uploadFile of this.uploadFiles) {
        let formData = new FormData()
        formData.append(`uploadFile`, uploadFile)

        await postFiles(`/peoples/${this.datum._id}/upload`, formData).then((json) => {
        }).catch((err) => {
          console.log(err)

          message = '添付ファイルのアップロードに失敗しました'

          if (err.response.data) {
            if (err.response.data.code && err.response.data.message) {
              message = err.response.data.message
            } else if (err.response.data.message) {
              message = err.response.data.message
            }
          }
        })

        if (message) { break }
      }

      return message
    },
    async doRemoveFiles () {
      if (!this.datum.Files.length || this.datum.Files.length === 0) { return }

      let message = null

      for (let file of this.datum.Files) {
        if (file.remove) {
          await deleteData(`/peoples/${this.datum._id}/files/${file._id}.${file.extension}`).then((json) => {
          }).catch((err) => {
            console.log(err)

            message = '添付ファイルの削除に失敗しました'

            if (err.response.data) {
              if (err.response.data.code && err.response.data.message) {
                message = err.response.data.message
              } else if (err.response.data.message) {
                message = err.response.data.message
              }
            }
          })

          if (message) { break }
        }
      }

      return message
    }
  }
}
</script>

<style scoped lang="stylus">
.body
  .form
    overflow-y scroll
    overflow-x hidden
    height calc(100vh - 3.75rem - 5.5rem - 4.75rem)

.input-educations-enrolledAt
.input-educations-graduatedAt
.input-careers-joinedAt
.input-careers-retiredAt
  max-width 11rem

.border.rounded
  min-height 3rem

.custom-file.b-form-file
  max-width 28rem
.uploadFiles
  .file
    height 2rem
    line-height 2rem
.removeUpdateFiles
  i
    font-size 1.5rem
    color #999
  padding 0 1rem 0 0.5rem

.files
  .file
    display inline-block
    word-break break-all
    .removeFiles
      i
        font-size 1.5rem
        color #999
      padding 0 1rem 0 0.5rem
      &.disabled
        display none
    &.remove
      a, button
        color red
        text-decoration line-through solid

.careers
.educations
.links
  .card
    .card-title
      width 100%
      display flex
      justify-content flex-end
      margin-top 0.5rem
      margin-right 0.5rem
      // z-index 1001
    .card-body
      // z-index 1000
.addEducations
.removeEducations
.addCareers
.removeCareers
.addLinks
.removeLinks
  z-index 1000
  i
    font-size 1.5rem
.addEducations
.addCareers
.addLinks
  padding 0.5rem 1rem 1.5rem 1rem
  i
    color #156eff
.removeEducations
.removeCareers
.removeLinks
  padding 0.5rem 1rem
  i
    color #999
  &.disabled
    display none

#input-tags
  >>> .b-form-tags-button
    white-space nowrap
    padding-left 1.5rem
    padding-right 1.5rem

#input-birth_year
  max-width 7rem
#input-birth_month
#input-birth_day
  max-width 5rem

.form-group.uploadFile >>> label::after
  content ''
.form-group.uploadFile >>> label.custom-file-label::after
  content '選択'
</style>
